export {marketsBySlugQuery} from './marketsBySlug.groq'
export {marketsBySlugSeoQuery} from './marketsBySlug.groq'
